<template>
  <Walkthrough 
    roomName="Cellule de prison"
    roomKey="jailcell"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="french"
  />
</template>
<script>

export default {
  name: 'Celda',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/jailcell-1920x1280.jpg",
      steps: [
        "Regardez en bas et inspectez le sol. Vous devriez trouver une clé sous une brique lâche.",
        "Regardez à droite et inspectez le miroir. Vous devriez y trouver une vieille lime à ongles cachée",
        "Regardez vers l'avant et inspectez le lit. Vous trouverez une tenue de prison en dessous.",
        "Maintenant, utilisez la lime à ongles sur le lit. Vous grattez un peu de peinture et trouvez les dessins d'un miroir, d'un évier, d'une porte et d'une bouche d’aération en dessous.",
        "En regardant toujours vers l'avant, inspectez l'oreiller, vous devriez trouver une lame. Elle vous sera utile plus tard. N'oubliez pas de la prendre avec vous. ",
        "Les images sur le lit étaient en fait des indices. En utilisant la direction dans laquelle ces éléments se trouvent dans la cellule, vous savez maintenant comment tourner la clé. Regardez à droite et utilisez la clé sur le tuyau. Tournez-la à droite, à droite, à gauche, puis vers le haut. Ceci devrait ramener le flux d'eau dans la cellule.",
        "Avec l'eau qui coule, regardez de nouveau vers l'avant et utilisez la tenue prison sur les toilettes pour la jeter là-dedans.",
        "Avec la tenue de prison coincée dans les toilettes, utilisez à nouveau les toilettes. L'eau commencera à déborder et l'eau montante vous conduira à la bouche d’aération où vous utiliserez la lame pour l'ouvrir et vous libérer. Félicitations pour votre évasion. Essayez de résoudre l’énigme de la pièce suivante par vous-même !"
        ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/fr/jailcell.vue